/**
 * SAM-553 — turns the `before`/`after` snapshots on a `GET /bookings/{id}/history` row into a
 * short "field: old → new" summary for the changelog tab. Pure so it's testable without the panel.
 */
export function diffSummary(
  before: Record<string, any> | null | undefined,
  after: Record<string, any> | null | undefined,
): string[] {
  if (!before && !after) return [];
  const keys = new Set([...Object.keys(before || {}), ...Object.keys(after || {})]);
  const lines: string[] = [];
  keys.forEach((key) => {
    const beforeVal = before ? before[key] : undefined;
    const afterVal = after ? after[key] : undefined;
    if (JSON.stringify(beforeVal) === JSON.stringify(afterVal)) return;
    lines.push(`${key}: ${formatValue(beforeVal)} → ${formatValue(afterVal)}`);
  });
  return lines;
}

function formatValue(value: unknown): string {
  if (value === undefined) return '—';
  if (value === null) return 'null';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
